import Loadable from '../../../components/loadable';

export default Loadable(() =>
  import(/* webpackChunkName: "layout-consumer-subheader" */ './index')
);
